module.exports = __webpack_public_path__ + "img/2-5.f6e82206.svg";